import { Form, Button, Modal, Table, Pagination, InputGroup, CloseButton, Dropdown, Stack, Row, Col } from "react-bootstrap";
import { convertSheetToJson } from "../util/excelReader";
import { Component } from "react";
import { subjectValidator } from "../util/validator";
import keycloak from "../util/keycloak";
import { debounce } from "../util/debounce";

const VISIBLE_PAGE_COUNT = 5
const PAGE_SIZE = 10

export class SubjectsTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userData: {
                subjects: [],
                requestedPage: 1,
                pages: 1,
            },
            leftMostPage: 1,
            rightMostPage: 1,
            schools: props.userDomain === 'District' ? [] : [props.userDomain],
            userDeleteId: undefined,
            currentUserSearchVal: '',
            addUsersModal: false,
            addType: 'bulkAdd',
            addUserName: '',
            addUserEmail: '',
            addUserSchool: props.userDomain === 'District' ? '' : props.userDomain,
        }
        this.apiManager = props.apiManager;
        this.handleUpload = this.handleUpload.bind(this)
        this.handleFileChange = this.handleFileChange.bind(this)
    }

    handleSearchInput = debounce(async (keyEvent) => {
        this.setState({currentUserSearchVal: keyEvent.target.value})
        await this.refreshUserList(1, keyEvent.target.value)
    }, 500)

    async refreshUserList(pageNum=1, searchQuery) {
        const userData = await this.apiManager.getSubjectPage(pageNum, PAGE_SIZE, searchQuery)
        this.setState({
            userData,
            leftMostPage: pageNum === 1 ? 1 : this.state.leftMostPage,
            rightMostPage: pageNum === 1 ? Math.min(VISIBLE_PAGE_COUNT, userData.pages) : this.state.rightMostPage,
        })
    }

    handleFileChange(event) {
        this.setState({
            file: event.target.files[0],
        })
    }

    handleUpload() {
        if (!this.state.file) {
            alert("Must select file before uploading")
            this.setState({file: null})
            return
        }
        if (!this.state.file.name.includes('.xlsx')) {
            alert("Must be excel format (.xlsx)")
            this.setState({file: null})
            return
        }
        convertSheetToJson(this.state.file, async (jsonData) => {
            const cleanedData = []
            const errors = []
            for(const item of jsonData) {
                const validatorRes = subjectValidator(item, this.state.schools)
                if (validatorRes.valid){
                    cleanedData.push({name: item.name, email: item.email, school: item.school})
                } else {
                    errors.push(validatorRes.msg)
                }
            }
            if (errors.length) {
                alert(`Excel file data not valid: "${errors[0]}" ${errors.length - 1 ? `+ ${errors.length - 1} errors` : '' }`)
                return
            }
            const resp = await this.apiManager.addSubjects(jsonData)
            if (!resp) {
                return
            }
            this.handleModalFields('addUsersModal', false)
            this.setState({file: null})
            if (this.state.currentUserSearchVal) {
                this.refreshUserList(1, this.state.currentUserSearchVal)
            } else {
                this.refreshUserList(1)
            }
        })
    }

    handlePageChange = async (requestedPage) => {
        this.refreshUserList(requestedPage)
    }

    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        if (this.props.userDomain === 'District') {
            const schools = await this.apiManager.getSchools()
            this.setState({schools})
        }
        this.refreshUserList()
    }

    setUserDeleteId = (subjectId) => {
        this.setState({userDeleteId: subjectId})
    }

    handleUserDelete = (deleteUserId) => {
        this.apiManager.deleteSubject(deleteUserId).then(result => {
            if (result) {
                this.setUserDeleteId(undefined);
                if (this.state.currentUserSearchVal) {
                    this.refreshUserList(1, this.state.currentUserSearchVal)
                } else {
                    this.refreshUserList(1)
                }
            }
        })
    }

    handleModalFields = (field, val) => {
        this.setState({[field]: val})
    }

    handleModalFieldTyping = field => (e) => {
        this.setState({[field]: e.target.value})
    }

    handleSingleUserAddition = async () => {
        const newUserData = {name: this.state.addUserName, email: this.state.addUserEmail, school: this.state.addUserSchool}
        const validatorRes = subjectValidator(newUserData, this.state.schools)
        if (!validatorRes.valid) {
            alert(validatorRes.msg)
            return
        }
        const resp = await this.apiManager.addSubjects([newUserData])
        if (!resp) {
            return
        }
        this.setState({addUsersModal: false, addUserName: '', addUserEmail: '', addUserSchool: this.props.userDomain === 'District' ? '' : this.props.userDomain})
        if (this.state.currentUserSearchVal) {
            this.refreshUserList(1, this.state.currentUserSearchVal)
        } else {
            this.refreshUserList(1)
        }
    }

    handlePageSelectorShift(direction) {
        if (direction === 'left') {
            this.setState({
                leftMostPage: Math.max(1, this.state.leftMostPage - VISIBLE_PAGE_COUNT),
                rightMostPage: this.state.leftMostPage - 1,
            })
        } else if (direction === 'right') {
            this.setState({
                leftMostPage: this.state.rightMostPage + 1,
                rightMostPage: Math.min(this.state.rightMostPage + VISIBLE_PAGE_COUNT, this.state.userData.pages)
            })
        }
    }

    render() {
        return ( 
            <div>
                <h3 className="mt-3">Users</h3>
                <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1"><i class="bi bi-search"></i></InputGroup.Text>
                    <Form.Control onChange={this.handleSearchInput} placeholder="Search..." />
                </InputGroup>
                <Table bordered>
                    <tbody>
                        {this.state.userData.subjects.map((item, idx) => 
                            <tr key={idx}>
                                <td>{item.name}</td>
                                <td>{item.email}</td>
                                <td>{item.school}</td>
                                <td><CloseButton onClick={() => this.setUserDeleteId(item._id)}/></td>
                            </tr>
                        )}
                        {this.state.userData.subjects.length === 0 && 
                            <tr>
                                <td>No users found</td>
                            </tr>
                        }
                    </tbody>
                </Table>
                <Row>
                    {this.state.userData.subjects.length > 0 &&
                    <Col xs={9}>
                        <Pagination>
                            {this.state.leftMostPage !== 1 && <Pagination.Prev onClick={() => this.handlePageSelectorShift('left')}/>}
                            {Array.from({ length: this.state.rightMostPage - this.state.leftMostPage + 1 }).map((_, index) => (
                                <Pagination.Item
                                    onClick={() => this.handlePageChange(this.state.leftMostPage + index)}
                                    key={this.state.leftMostPage + index}
                                    active={this.state.leftMostPage + index === this.state.userData.requestedPage}
                                >
                                    {this.state.leftMostPage + index}
                                </Pagination.Item>
                            ))}
                            {this.state.rightMostPage !== this.state.userData.pages && <Pagination.Next onClick={() => this.handlePageSelectorShift('right')}/>}
                        </Pagination>
                    </Col>
                    }
                    <Col className="text-end" xs={3}>
                        <Button variant="primary" className="ms-auto" onClick={() => this.handleModalFields('addUsersModal', true)}>Add Users</Button>
                    </Col>
                    
                </Row>

                {/* Modals and offcanvases */}
                <Modal show={!!this.state.userDeleteId} onHide={() => {this.setUserDeleteId(undefined)}}>
                    <Modal.Header>
                        <Modal.Title>Are you sure you wish to delete this user?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>User will no longer be available for future form submissions but current responses with user will still exist.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {this.setUserDeleteId(undefined)}}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => {this.handleUserDelete(this.state.userDeleteId)}}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.addUsersModal} onHide={() => this.handleModalFields('addUsersModal', false)}>
                    <Modal.Header>
                        <Modal.Title>Add Users</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="mb-3">
                            <Form.Check 
                                inline
                                label="Bulk add users"
                                name="addType"
                                value="bulkAdd"
                                type="radio"
                                checked={this.state.addType === "bulkAdd"}
                                onChange={() => this.handleModalFields('addType', 'bulkAdd')}
                            />
                            <Form.Check 
                                inline
                                label="Single user"
                                name="addType"
                                value="singleUser"
                                type="radio"
                                checked={this.state.addType === "singleUser"}
                                onChange={() => this.handleModalFields('addType', 'singleUser')}
                            />
                        </Form>
                        {this.state.addType === 'bulkAdd' ?
                            <Form>
                                <Form.Group controlId="usersFile" className="my-3">
                                    <Form.Label>Select excel file with headers (name, email, school) to add users</Form.Label>
                                    <Form.Control className="w-auto" type="file" onChange={this.handleFileChange} />
                                </Form.Group>
                            </Form> :
                            <Form>
                                <Form.Control type="text" placeholder="Name" value={this.state.addUserName} onChange={this.handleModalFieldTyping('addUserName')} />
                                <br />
                                <Form.Control type="email" placeholder="Email address" value={this.state.addUserEmail} onChange={this.handleModalFieldTyping('addUserEmail')} />
                                <br />
                                <Dropdown>
                                    <Dropdown.Toggle>{this.state.addUserSchool || 'Select school...'}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.schools.map(school => 
                                            <Dropdown.Item onClick={() => this.handleModalFields('addUserSchool', school)}>{school}</Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.handleModalFields('addUsersModal', false)}>
                            Cancel
                        </Button>
                        {this.state.addType === 'bulkAdd' ?
                        <Button variant="primary" onClick={this.handleUpload}>
                            Upload
                        </Button> :
                        <Button variant="primary" onClick={() => this.handleSingleUserAddition()}>Add user</Button>
                        }
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}